import { render, staticRenderFns } from "./LectureCategoryList.vue?vue&type=template&id=d473411a"
import script from "./LectureCategoryList.vue?vue&type=script&lang=js"
export * from "./LectureCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports